import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';

import CloseIcon from '@material-ui/icons/Close';

import AppContent from '../../../_Shared/Layout/AppContent';
import SlideTransition from '../../../_Shared/Transitions/SlideTransition';

const _ = require('lodash');
const styles = theme => ({
    appBar: {
        position: 'relative'
    },
    flex: {
        flex: 1
    },
    table: {
        marginBottom: theme.spacing.unit * 3
    }
});

class ImportQueryColumns extends React.Component {

    constructor(props) {
        super(props);

        this.state = { 
            columnsChecked: []
        };
    }
    
    import = () => { }

    selectAll = (query, checked, index) => {
        const { columnsChecked } = this.state;
        let columns = [];
        if (checked) { 
            columns = columnsChecked.filter(x => !query.columns.includes(x));
            columns.push(...query.columns.map(x => x.id));
        }
        //else { columnsChecked.splice(column.id, 1); }
        this.setState({ columnsChecked: columns });
    }

    columnChecked = (column, checked, index) => {
        const { columnsChecked } = this.state;

        if (checked) { columnsChecked.push(column.id); }
        else { columnsChecked.splice(column.id, 1); }

        this.setState({ columnsChecked });
    }

    render() {
        const { classes, open, onClose, parentQueries } = this.props;
        return (<Dialog fullScreen open={open} onClose={onClose} TransitionComponent={SlideTransition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
                            <Typography variant="title" color="inherit" className={classes.flex}>{this.props.title}</Typography>
                            <Button color="inherit" onClick={this.import}>Import</Button>
                        </Toolbar>
                    </AppBar>
                    <AppContent>
                        <Grid container spacing={24}>
                            <Grid item xs={5}>
                            {
                                parentQueries &&
                                [].concat(parentQueries).map((query, queryIndex) => 
                                <Table className={classes.table} key={`table_${queryIndex}`}>
                                    <TableHead>
                                        <TableRow classes={{ head: classes.head }}>
                                            <TableCell padding="checkbox">
                                                <Checkbox onChange={(e, c) => this.selectAll(query, c, queryIndex)} />
                                            </TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Data type</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {
                                        query.columns &&
                                        [].concat(query.columns).map((column, rowIndex) => 
                                        <TableRow key={`table_body_${queryIndex}_${rowIndex}`}>
                                            <TableCell padding="checkbox">
                                                <Checkbox value={column.id} checked={column.id} onChange={(e, c) => this.columnChecked(column, c, rowIndex)} />
                                            </TableCell>
                                            <TableCell>{column.name}</TableCell>
                                            <TableCell>{column.dataType}</TableCell>
                                        </TableRow>)
                                    }
                                    </TableBody>
                                </Table>)
                            }
                            </Grid>
                            <Grid item xs={7}></Grid>
                        </Grid>
                    </AppContent>
                </Dialog>);
    }
}

ImportQueryColumns.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImportQueryColumns);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/QueryEditors/Common/ImportQueryColumns.js